import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Resource {
  id: string;
  title: string;
  description: string;
  type: string;
  icon: string;
  downloadUrl: string;
}

interface ResourceLibraryProps {
  resources: Resource[];
}

const ResourceLibrary = ({ resources }: ResourceLibraryProps) => {
  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-display font-bold text-foreground mb-4">
          Downloadbare Resources
        </h2>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Praktische gidsen, templates en tools om uw AI-transformatie te versnellen
        </p>
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {resources.map((resource) => (
          <div
            key={resource.id}
            className="glassmorphic rounded-2xl p-6 hover:shadow-premium transition-all duration-300 hover:-translate-y-1 group"
          >
            <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors duration-300">
              <Icon name={resource.icon as any} size={28} className="text-primary" />
            </div>
            
            <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-secondary/10 text-secondary mb-3">
              {resource.type}
            </span>
            
            <h3 className="text-lg font-display font-bold text-foreground mb-2 line-clamp-2">
              {resource.title}
            </h3>
            
            <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
              {resource.description}
            </p>
            
            <button className="w-full flex items-center justify-center space-x-2 px-4 py-2.5 rounded-lg bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-all duration-300">
              <Icon name="ArrowDownTrayIcon" size={18} />
              <span>Download</span>
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResourceLibrary;